import MetricDetailModal from './MetricDetailModal';

export default MetricDetailModal;
